import React from 'react';
import Radio from './components/Radio';
import { Controller, type Control } from 'react-hook-form';

interface Props {
  name: string;
  control: Control<any, any>;
  items: Radio.Item[];
}

const RadioGroup = ({ name, control, items }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <>
          {items.map((item) => {
            const isSelected = item.value === value;

            return (
              <Radio
                key={item.value}
                {...item}
                onPress={onChange}
                isSelected={isSelected}
              />
            );
          })}
        </>
      )}
    />
  );
};

export default RadioGroup;
